import React from 'react';
import { NavLink, NavLinkProps, useMatch } from 'react-router';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IDataTestId } from '@custom';

type TProps = {
  text: string;
  segment?: string;
} & NavLinkProps &
  IDataTestId;

function MenuItem({ className, to, text, segment = '', ...rest }: TProps) {
  const match = useMatch(`/${segment}/*`);

  return (
    <NavLink
      {...rest}
      className={({ isActive }) => `${className} ${isActive || match ? 'active' : ''}`}
      to={to}
      data-testid={rest?.['data-testid']}
    >
      <ChevronRightIcon
        className="active-icon tw:text-secondary-400 tw:rounded-full tw:mr-2 tw:bg-primary-100"
        style={{ fontSize: 12 }}
      />
      <span>{text}</span>
    </NavLink>
  );
}

export default MenuItem;
